enum timeZonesEnam {
    GMT_MINUS_3 = 'Etc/GMT-3',
    GMT_MINUS_4 = 'Etc/GMT-4',
    GMT_MINUS_5 = 'Etc/GMT-5',
    GMT_MINUS_6 = 'Etc/GMT-6',
    GMT_MINUS_7 = 'Etc/GMT-7',
    GMT_MINUS_8 = 'Etc/GMT-8',
    GMT_MINUS_9 = 'Etc/GMT-9',
    GMT_MINUS_10 = 'Etc/GMT-10',
    GMT_MINUS_11 = 'Etc/GMT-11'
}
export default timeZonesEnam;